import { ApolloLink } from "@apollo/client";
import { isProductionEnvironment } from "mt-shared/environment";
import qs from "query-string";
import { Tracker } from "./analytics2";

interface ShareASaleEvent {
  amount: number;
  currency: string;
  tracking: string;
}

const SHAREASALE_MERCHANT_ID = 80059;

function trackShareSale({ amount, currency, tracking }: ShareASaleEvent) {
  const queryString = qs.stringify({
    amount,
    currency,
    tracking,
    transtype: "sale",
    merchantID: SHAREASALE_MERCHANT_ID,
  });

  const src = `https://shareasale.com/sale.cfm?${queryString}`;

  if (isProductionEnvironment) {
    const image = document.createElement("img");
    image.width = 1;
    image.height = 1;
    image.src = src;
  } else {
    console.warn("[dev-mode] track-share-sale", src); // eslint-disable-line
  }
}

interface PurchaseData {
  productId: string;
  productName: string;
  orderId: string;
  amountInMajorUnits: number;
  currencyCode: string;
  email: string;
  phoneNumber: string | undefined | null;
  couponCode?: string;
  isReturningCustomer: boolean;
  itemCount?: number;
}

export function trackTransaction({
  productId,
  productName,
  orderId,
  amountInMajorUnits,
  currencyCode,
  email,
  phoneNumber,
  couponCode,
  isReturningCustomer,
  itemCount = 1,
}: PurchaseData) {
  trackShareSale({
    amount: amountInMajorUnits,
    currency: currencyCode,
    tracking: orderId,
  });

  if (window && typeof window.gtag === "function") {
    window.gtag("set", "user_data", {
      email: email,
      phone_number: phoneNumber,
    });

    window.gtag("event", "purchase", {
      transaction_id: orderId,
      value: amountInMajorUnits,
      currency: currencyCode,
      cart_item_count: itemCount,
      is_bulk_booking: itemCount > 1,
      ...(couponCode && { coupon: couponCode }),
      items: [
        {
          item_id: productId,
          item_name: productName,
          item_brand: "MagicalTrip",
          price: amountInMajorUnits,
          quantity: 1,
        },
      ],
    });
    window.gtag("event", "conversion", {
      send_to: "AW-877375277/25O3CJ2t4PIYEK3erqID",
      value: amountInMajorUnits,
      currency: currencyCode,
    });
  }

  if (window && typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      value: amountInMajorUnits,
      currency: currencyCode,
      bookingId: orderId,
      couponCode,
      customerAcquisition: isReturningCustomer ? "RETURNING" : "NEW",
    });
  }
}

export const createApolloAnalyticsLink = (tracker: Tracker) =>
  new ApolloLink((operation, forward) => {
    if (!forward) {
      return null;
    }
    return forward(operation);
  });
